export { default as KlarnaExpressCheckoutButton } from './KlarnaExpressCheckoutButton'



// WEBPACK FOOTER //
// ./src/components/klarnaExpressCheckoutButton/index.js